import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  ChequeBookListDto,
  ChequeBookDetailDto,
  CreateChequeBookRequest,
  ChequeBookFilter,
  ChequeAllocation,
} from '@/types/chequeBook.types';

export const chequeBookApi = {
  /** GET /api/v1/cheque-books — books with their leaf counts (auto-scoped to the caller's company) */
  getList: (filter?: ChequeBookFilter) =>
    apiClient.get<ApiResponse<PagedResult<ChequeBookListDto>>>('/cheque-books', { params: filter }),

  /**
   * GET /api/v1/cheque-books/allocation — how a cheque line on this account gets its number.
   *
   * One call for three answers that are useless apart: the company's mode, whether this account has
   * any book at all, and each book's next available leaf (GAP-001).
   */
  getAllocation: (bankAccountId: string) =>
    apiClient.get<ApiResponse<ChequeAllocation>>('/cheque-books/allocation', { params: { bankAccountId } }),

  /** GET /api/v1/cheque-books/{id} — the book and every leaf in it, including who holds what */
  getById: (id: string) =>
    apiClient.get<ApiResponse<ChequeBookDetailDto>>(`/cheque-books/${id}`),

  /** POST /api/v1/cheque-books — register a book received from the bank */
  create: (data: CreateChequeBookRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/cheque-books', data),

  /** POST /api/v1/cheque-books/{id}/close — close the book and void its unused leaves */
  close: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/cheque-books/${id}/close`, { reason }),

  /** POST /api/v1/cheque-books/leaves/{leafId}/void — spoiled, torn or destroyed */
  voidLeaf: (leafId: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/cheque-books/leaves/${leafId}/void`, { reason }),

  /**
   * POST /api/v1/cheque-books/leaves/{leafId}/release — hand a held number back.
   * The manual counterpart to the stale sweep, for a document nobody intends to finish.
   */
  releaseLeaf: (leafId: string) =>
    apiClient.post<ApiResponse<object>>(`/cheque-books/leaves/${leafId}/release`, {}),
};
